export function normalizePersonQuery(value) {
  return String(value || "").normalize("NFD").replace(/\p{M}/gu, "").toLocaleLowerCase("fr").replace(/[^\p{L}\p{N}]+/gu, " ").trim();
}

export function searchPeople(people, query, limit = 6) {
  const normalized = normalizePersonQuery(query);
  if (!normalized) return [];
  const terms = normalized.split(/\s+/);
  return people.map(person => {
    const name = normalizePersonQuery(person.name);
    return { person, name, score: name === normalized ? 0 : name.startsWith(normalized) ? 1 : 2 };
  }).filter(({ name }) => terms.every(term => name.includes(term)))
    .sort((a, b) => a.score - b.score || a.person.name.localeCompare(b.person.name, "fr") || a.person.id.localeCompare(b.person.id))
    .slice(0, limit).map(({ person }) => person);
}

export function installMobileSearch(getPeople, selectPerson) {
  const dialog = document.querySelector("#searchDialog"), trigger = document.querySelector("#mobileSearchButton");
  const input = document.querySelector("#mobilePersonSearch"), list = document.querySelector("#mobileSearchResults");
  const feedback = document.querySelector("#mobileSearchFeedback"), mobile = matchMedia("(max-width: 760px)");
  let matches = [], previousResults = "";
  function select(person) {
    input.blur(); dialog.close();
    selectPerson(person.id);
    const title = document.querySelector("#inspectorTitle");
    title.setAttribute("tabindex", "-1"); title.focus({ preventScroll: true });
  }
  function refresh() {
    const loading = document.querySelector("#app").getAttribute("aria-busy") === "true";
    matches = loading ? [] : searchPeople(getPeople(), input.value);
    const typed = Boolean(normalizePersonQuery(input.value));
    const message = !typed ? "" : matches.length ? `${matches.length} suggestion${matches.length > 1 ? "s" : ""}`
      : loading ? "Le réseau se charge…" : "Aucune personne trouvée dans le réseau collecté.";
    if (feedback.textContent !== message) feedback.textContent = message;
    const signature = JSON.stringify(matches);
    if (signature === previousResults) return;
    previousResults = signature;
    const focused = list.contains(document.activeElement) ? document.activeElement.dataset.person : null;
    list.replaceChildren();
    for (const person of matches) {
      const item = document.createElement("li"), button = document.createElement("button"), name = document.createElement("span");
      button.type = "button"; button.dataset.person = person.id; name.textContent = person.name; button.append(name);
      if (person.birthYear != null) { const year = document.createElement("small"); year.textContent = `né·e en ${person.birthYear}`; button.append(year); }
      button.addEventListener("click", () => select(person));
      item.append(button); list.append(item);
      if (person.id === focused) button.focus();
    }
  }
  trigger.addEventListener("click", () => {
    input.value = ""; refresh(); dialog.showModal(); trigger.setAttribute("aria-expanded", "true"); input.focus();
  });
  document.querySelector("#closeSearch").addEventListener("click", () => dialog.close());
  dialog.addEventListener("close", () => { input.blur(); trigger.setAttribute("aria-expanded", "false"); });
  input.addEventListener("input", refresh);
  input.addEventListener("keydown", event => {
    if (event.isComposing) return;
    if (event.key === "ArrowDown") { event.preventDefault(); list.querySelector("button")?.focus(); }
    if (event.key === "Enter") {
      event.preventDefault(); refresh();
      const exact = matches.filter(person => normalizePersonQuery(person.name) === normalizePersonQuery(input.value));
      if (matches.length === 1 || exact.length === 1) select(exact[0] || matches[0]);
      else list.querySelector("button")?.focus();
    }
  });
  // A live snapshot can arrive while the keyboard is already open.
  document.addEventListener("entourages:people-updated", () => { if (dialog.open) refresh(); });
  mobile.addEventListener("change", () => { if (!mobile.matches && dialog.open) dialog.close(); });
}
